// Subscription plan mapping
export const subscriptionPlanMap = {
  'Monthly Standard': 'Basic',
  'Annual Standard': 'Basic',
  'Monthly Pro': 'Pro',
  'Annual Pro': 'Pro',
  'Freemium': 'Freemium',
  'Enterprise': 'Enterprise'
};

export const plans = {
  Freemium: {
    title: "Freemium",
    priceMonthly: "Free",
    priceAnnual: "Free",
    creditsByDefault: 300,
    paypalPlanId: {
      monthly: null,
      annual: null
    },
    displayNames: {
      monthly: "Freemium",
      annual: "Freemium"
    },
  },
  Basic: {
    title: "Basic",
    priceMonthly: 20,
    priceAnnual: 16,
    creditsByDefault: 900,
    paypalPlanId: {
      monthly: "P-2UW853875B7306247M7DQIJI",
      annual: "P-4TC51062MR105871XM7DQHCI"
    },
    displayNames: {
      monthly: "Monthly Standard",
      annual: "Annual Standard"
    },
  },
  Pro: {
    title: "Pro",
    priceMonthly: 100,
    priceAnnual: 80,
    creditsByDefault: 6000,
    paypalPlanId: {
      monthly: "P-78N035985L298241YM7DQHXA",
      annual: "P-72S72037CT989103CM7DQEHI"
    },
    displayNames: {
      monthly: "Monthly Pro",
      annual: "Annual Pro"
    },
  },
  Enterprise: {
    title: "Enterprise",
    priceMonthly: "Individual Terms",
    priceAnnual: "Individual Terms",
    creditsByDefault: null,
    paypalPlanId: {
      monthly: null,
      annual: null
    },
    displayNames: {
      monthly: "Enterprise",
      annual: "Enterprise"
    },
  }
};
